import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Box, Typography } from '@mui/material'
import { t } from 'i18next'

import { unit, COLORS, ICONS } from '@hcr/ui'
import { isNotNull, isNotUndefined } from '@hcr/utils'

import { dateFormatter } from '../../../../../utils'
import type { BookingListPreviewProps } from '../../../../common/booking-list/types'

interface BookingListDescriptionProps extends Pick<BookingListPreviewProps, 'dateRange' | 'totalTickets'> {
  isActive?: boolean
}

export const BookingListDescription = ({ dateRange, totalTickets, isActive }: BookingListDescriptionProps) => {
  return (
    <Box display='inline'>
      <Box display='inline' marginRight={unit(3.5)}>
        {isNotUndefined(dateRange) ? (
          <Typography variant='meta' fontWeight='initial' color={COLORS.black}>
            {dateFormatter.formatDateRange(dateRange)}
          </Typography>
        ) : (
          <Typography variant='meta' fontWeight='initial' color={COLORS.black}>
            {t('booking.no-accommodation-booked')}
          </Typography>
        )}
      </Box>

      {isNotNull(totalTickets) && totalTickets > 0 && (
        <Typography variant='meta' fontWeight='initial' color={COLORS.black} sx={{ whiteSpace: 'nowrap' }}>
          <FontAwesomeIcon color={COLORS.black} icon={ICONS.farLayerGroup} style={{ marginRight: unit(1) }} />
          {totalTickets > 1
            ? t('utils.tickets-count-plural', { count: totalTickets })
            : t('utils.tickets-count', { count: totalTickets })}
        </Typography>
      )}
    </Box>
  )
}
